
import React, { useState } from 'react'

import { message } from 'antd';
import cn from 'classnames';
import { inject, observer } from 'mobx-react'
import { useRouter } from 'next/router';

import { SocialAPI } from '@api/social';
import { COMMUNITY_PATHS } from '@constants/index';
import { BackTop, Select, TabPane, Tabs } from '@element/index';
import useAuthSession from '@lib/hooks/useAuthSession'
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import pubsub from '@lib/scripts/pubsub'
import I18n from '@utils/i18n';
import { PostEntryBtn } from '@widget/community'
import SocialFeed from '@widget/post/SocialFeed';
import { zoneOptions } from '@widget/user/OtherSettings/const';

import RecommendData from '../recommend';

import styles from './index.module.less'
const RecommendTabs = (props) => {
  const { userStore, className } = props;
  const [activeKey, setActiveKey] = useState('1');
  const [selectValue, setSelectValue] = useState(userStore?.socialUserInfo.zone)
  const quickPostDone = () => {
    setActiveKey('2')
  }
  useIsomorphicLayoutEffect(() => {
    pubsub.subscribe('QUICK_POST_DONE', quickPostDone)
    return () => {
      pubsub.unSubscribe('QUICK_POST_DONE', quickPostDone)
    }
  }, [])
  const isLogin = useAuthSession({ redirectTo: null });
  const router = useRouter();

  useIsomorphicLayoutEffect(() => {
    setActiveKey(router.query?.activeKey || '1')
  }, [router.query])
  const onChangeSelect = async (option) => {
    const res = await SocialAPI.updateCountryLanguageZone({ id: userStore?.userInfo?.id, zone: option })
    if (res.result) {
      setSelectValue(res?.result?.zone);
      props.userStore.updateSocialUserInfo(res.result);
      pubsub.publish('UPDATE_SOCIAL_FEED');
      const label = zoneOptions().filter(item => item.value === res?.result?.zone)[0].label;
      message.success(I18n.t('qUBmbZgX', { label: label }));
    } else {
      message.error(I18n.t('dkEyxJnZ'));
    }
  }
  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.communityTop}>
        <h1 className={styles.communityTitle}>{I18n.t('community')}</h1>
        {isLogin && <Select
          className={styles.select}
          selectBtnCalssName={styles.selectBtn}
          options={zoneOptions()}
          value={selectValue}
          onChange={(option) => onChangeSelect(option.value)}
          />}
      </div>
      <Tabs
        type='marketTab'
        activeKey={activeKey}
        className={styles.tab}
        onChange={(activeKey) => {
          setActiveKey(activeKey)
          router.replace({
            pathname: COMMUNITY_PATHS.COMMUNITY,
            query: {
              activeKey
            }
          })
        }}
      >
        <TabPane tab={<h2>{I18n.t('community_recommend')}</h2>} key='1' type='marketTab'>
          <div style={{ 'padding-top': '15px' }}>
            <RecommendData />
            <SocialFeed
              feedParamUser={'post'}
              feedParamType={'recommend'}
              zone={selectValue}
              limit={6}
              isLoadMore={true}
            />
          </div>
        </TabPane>
        <TabPane tab={<h2>{I18n.t('recent')}</h2>} key='2' type='marketTab'>
          <div style={{ 'padding-top': '15px' }}>
            <SocialFeed
              feedParamUser={'post'}
              feedParamType={'square'}
              zone={selectValue}
              limit={6}
              tab="recent"
              isLoadMore={true}
            />
          </div>
        </TabPane>
        {isLogin && (<TabPane tab={<h2>{I18n.t('profile_follow_action')}</h2>} key='3' type='marketTab'>
          <div style={{ 'padding-top': '15px' }}>
            <SocialFeed
              feedParamUser={'post'}
              feedParamType={userStore?.userInfo?.id}
              limit={6}
              isLoadMore={true}
            />
          </div>
        </TabPane>)}

      </Tabs>

      <BackTop />
      <PostEntryBtn className={styles.postEntryBtn} />
    </div>
  )
};

export default inject(rootStore => {
  return {
    userStore: rootStore.store.userStore
  }
})(observer(RecommendTabs))
